import { FILTER_KEY } from "hooks/filter-keys";
import type { Dataset } from "models/colors";

interface ResolveDatasetInput {
  dataset: Dataset | undefined;
  /** Output of `checkInternalUser`: internal login, not a CDC user, External View off. */
  isInternal: boolean;
  flagEnabled: boolean;
}

/**
 * The backend honours `dataset=cleaned` for any internal caller and is not
 * feature-flag gated, so the webapp must only ask for it when the user chose it
 * AND is allowed to see it AND the flag is on.
 */
export const resolveDataset = ({
  dataset,
  isInternal,
  flagEnabled,
}: ResolveDatasetInput): Dataset =>
  dataset === "cleaned" && isInternal && flagEnabled ? "cleaned" : "original";

/** The backend defaults to the original dataset, so only the opt-in is sent. */
export const appendDatasetParam = (
  params: URLSearchParams,
  dataset: Dataset,
) => {
  if (dataset === "cleaned") {
    params.set("dataset", dataset);
  }
};

const DATASET_DEPENDENT_PARAMS: string[] = [
  FILTER_KEY.OEM_NAME,
  FILTER_KEY.IS_COLOR_SYSTEM,
  FILTER_KEY.COLOR_SYSTEM_CODE,
];

/**
 * Drops the filters whose option lists differ between the original and the
 * cleaned dataset (OEM, color system / code) from a route's query string, so a
 * dataset switch never lands on an unexplained empty list. Customer, the OEM
 * color pick (its lists read the cleaned data either way) and every other
 * filter are kept.
 */
export const clearDatasetDependentFilters = (route: string): string => {
  const url = new URL(route, window.location.origin);
  for (const param of DATASET_DEPENDENT_PARAMS) {
    url.searchParams.delete(param);
  }
  return `${url.pathname}${url.search}${url.hash}`;
};
